module.exports = __webpack_public_path__ + "img/8-3.c803d014.png";